// src/pages/CommunityHub.js - 集成CityReview版本
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CityReview from './CityReview'; // 导入CityReview组件

const CommunityHub = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('review');
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [messageInput, setMessageInput] = useState('');

    // 聊天消息数据保持不变
    const chatMessages = [
        {
            id: 1,
            author: 'Travel Expert',
            time: '10:30',
            message: 'Has anyone visited the Temple of Heaven? Planning to go tomorrow.',
            avatar: 'https://i.pravatar.cc/150?img=1'
        },
        {
            id: 2,
            author: 'Local Guide Zhang',
            time: '10:32',
            message: 'Go early in the morning around 6am. You can see locals doing Tai Chi, really authentic experience!',
            avatar: 'https://i.pravatar.cc/150?img=2',
            isReply: true
        },
        {
            id: 3,
            author: 'Photography Fan',
            time: '10:35',
            message: 'Sunset is amazing there. Check out Jingshan Park too for the best city views!',
            avatar: 'https://i.pravatar.cc/150?img=3'
        }
    ];

    return (
        <>
            <style>{`
        /* 保持之前的所有样式 */
        .community-container {
          width: 100%;
          max-width: 430px;
          height: 100vh;
          height: 100dvh;
          margin: 0 auto;
          background: #f8f8f8;
          display: flex;
          flex-direction: column;
          position: relative;
        }
        
        /* Header - 极简风格 */
        .comm-header {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(0, 0, 0, 0.06);
          padding: 50px 20px 0;
          position: sticky;
          top: 0;
          z-index: 10;
        }
        
        .comm-header-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }
        
        .comm-back {
          width: 32px;
          height: 32px;
          background: #f0f0f0;
          border: none;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #6a6a6a;
        }
        
        .comm-title {
          flex: 1;
          font-size: 16px;
          font-weight: 400;
          color: #1a1a1a;
        }
        
        /* Tabs */
        .comm-tabs {
          display: flex;
          justify-content: space-around;
          padding: 12px 0;
        }
        
        .comm-tab-btn {
          flex: 1;
          padding: 8px;
          background: none;
          border: none;
          font-size: 14px;
          color: #8a8a8a;
          cursor: pointer;
          position: relative;
          transition: all 0.3s;
        }
        
        .comm-tab-btn.active {
          color: #2d2d2d;
          font-weight: 500;
        }
        
        .comm-tab-btn.active::after {
          content: '';
          position: absolute;
          bottom: -12px;
          left: 50%;
          transform: translateX(-50%);
          width: 24px;
          height: 2px;
          background: #2d2d2d;
          border-radius: 1px;
        }
        
        /* Content Area */
        .comm-content {
          flex: 1;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          position: relative;
        }
        
        /* Review Section - 容器样式 */
        .review-wrapper {
          height: 100%;
          overflow: hidden;
          position: relative;
        }
        
        /* Chat Section 和其他样式保持不变 */
        .chat-section {
          padding: 16px;
          padding-bottom: 80px;
        }
        
        .chat-group-header {
          text-align: center;
          margin-bottom: 20px;
        }
        
        .chat-group-title {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 14px;
          color: #667eea;
          margin-bottom: 4px;
        }
        
        .chat-group-subtitle {
          font-size: 12px;
          color: #8a8a8a;
        }
        
        .chat-message {
          display: flex;
          gap: 10px;
          margin-bottom: 16px;
          opacity: 0;
          animation: fadeIn 0.3s forwards;
        }
        
        @keyframes fadeIn {
          to { opacity: 1; }
        }
        
        .chat-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
          flex-shrink: 0;
        }
        
        .chat-bubble {
          flex: 1;
          background: white;
          border-radius: 12px;
          padding: 10px 14px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }
        
        .chat-author {
          font-size: 13px;
          font-weight: 500;
          color: #2d2d2d;
          margin-bottom: 4px;
          display: flex;
          justify-content: space-between;
        }
        
        .chat-time {
          font-size: 11px;
          color: #9a9a9a;
          font-weight: 400;
        }
        
        .chat-text {
          font-size: 14px;
          color: #4a4a4a;
          line-height: 1.4;
        }
        
        /* Input Area */
        .chat-input-area {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          max-width: 430px;
          margin: 0 auto;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-top: 1px solid rgba(0, 0, 0, 0.06);
          padding: 12px 16px;
          padding-bottom: max(12px, env(safe-area-inset-bottom));
          display: flex;
          gap: 10px;
          align-items: center;
        }
        
        .chat-input {
          flex: 1;
          padding: 10px 16px;
          background: #f5f5f5;
          border: none;
          border-radius: 20px;
          font-size: 14px;
          outline: none;
        }
        
        .chat-send-btn {
          width: 36px;
          height: 36px;
          background: #2d2d2d;
          border: none;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: white;
          transition: all 0.2s;
        }
        
        /* Create Modal 样式保持不变 */
        .create-modal {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          max-width: 430px;
          margin: 0 auto;
          background: white;
          border-radius: 24px 24px 0 0;
          padding: 24px 20px;
          padding-bottom: max(24px, env(safe-area-inset-bottom));
          box-shadow: 0 -10px 40px rgba(0,0,0,0.1);
          z-index: 30;
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .modal-handle {
          width: 36px;
          height: 4px;
          background: #d0d0d0;
          border-radius: 2px;
          margin: 0 auto 20px;
        }
        
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }
        
        .modal-title-section {
          text-align: center;
          flex: 1;
        }
        
        .modal-title {
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
        }
        
        .modal-close {
          width: 28px;
          height: 28px;
          background: #f5f5f5;
          border: none;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          position: absolute;
          right: 20px;
        }
        
        /* 其他modal样式保持不变 */
        .modal-input {
          width: 100%;
          padding: 12px 16px;
          background: #f8f8f8;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          margin-bottom: 12px;
          outline: none;
        }
        
        .modal-textarea {
          width: 100%;
          padding: 12px 16px;
          background: #f8f8f8;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          margin-bottom: 16px;
          outline: none;
          resize: none;
          min-height: 100px;
        }
        
        .modal-tools {
          display: flex;
          justify-content: center;
          gap: 24px;
          margin-bottom: 20px;
        }
        
        .modal-tool {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          padding: 12px;
          background: #f8f8f8;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .modal-publish-btn {
          width: 100%;
          padding: 16px;
          background: #2d2d2d;
          color: white;
          border: none;
          border-radius: 16px;
          font-size: 15px;
          font-weight: 400;
          cursor: pointer;
          transition: all 0.2s;
        }
      `}</style>

            <div className="community-container">
                {/* Header */}
                <div className="comm-header">
                    <div className="comm-header-top">
                        <button className="comm-back" onClick={() => navigate(-1)}>
                            <i className="bi bi-arrow-left"></i>
                        </button>
                        <div className="comm-title">Community Hub</div>
                    </div>

                    <div className="comm-tabs">
                        <button
                            className={`comm-tab-btn ${activeTab === 'review' ? 'active' : ''}`}
                            onClick={() => setActiveTab('review')}
                        >
                            Review
                        </button>
                        <button
                            className={`comm-tab-btn ${activeTab === 'chat' ? 'active' : ''}`}
                            onClick={() => setActiveTab('chat')}
                        >
                            Chat
                        </button>
                        <button
                            className={`comm-tab-btn ${activeTab === 'publish' ? 'active' : ''}`}
                            onClick={() => setActiveTab('publish')}
                        >
                            Publish
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="comm-content">
                    {activeTab === 'review' && (
                        <div className="review-wrapper">
                            {/* 直接嵌入CityReview组件 */}
                            <CityReview city="Montreal" />
                        </div>
                    )}

                    {activeTab === 'chat' && (
                        <div className="chat-section">
                            <div className="chat-group-header">
                                <div className="chat-group-title">
                                    <i className="bi bi-people"></i>
                                    Montreal Travel
                                </div>
                                <div className="chat-group-subtitle">
                                    Active 10 min ago • 10.3k members
                                </div>
                            </div>

                            {chatMessages.map(msg => (
                                <div key={msg.id} className="chat-message">
                                    <img src={msg.avatar} alt="" className="chat-avatar" />
                                    <div className="chat-bubble">
                                        <div className="chat-author">
                                            <span>{msg.author}</span>
                                            <span className="chat-time">{msg.time}</span>
                                        </div>
                                        <div className="chat-text">{msg.message}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {activeTab === 'publish' && (
                        <div style={{ padding: '20px', paddingBottom: '100px' }}>
                            {/* 直接显示发布表单 */}
                            <div style={{
                                background: 'white',
                                borderRadius: '16px',
                                padding: '20px'
                            }}>
                                <h3 style={{
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    color: '#1a1a1a',
                                    marginBottom: '20px',
                                    textAlign: 'center'
                                }}>
                                    Create Content
                                </h3>

                                <input
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px',
                                        background: '#f8f8f8',
                                        border: 'none',
                                        borderRadius: '12px',
                                        fontSize: '14px',
                                        marginBottom: '12px',
                                        outline: 'none'
                                    }}
                                    placeholder="Title"
                                />

                                <textarea
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px',
                                        background: '#f8f8f8',
                                        border: 'none',
                                        borderRadius: '12px',
                                        fontSize: '14px',
                                        marginBottom: '16px',
                                        outline: 'none',
                                        resize: 'none',
                                        minHeight: '100px'
                                    }}
                                    placeholder="Share your travel story..."
                                ></textarea>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: '24px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '12px',
                                        background: '#f8f8f8',
                                        borderRadius: '12px',
                                        cursor: 'pointer'
                                    }}>
                                        <i className="bi bi-camera" style={{ fontSize: '20px', color: '#4a4a4a' }}></i>
                                        <span style={{ fontSize: '11px', color: '#6a6a6a' }}>Photo</span>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '12px',
                                        background: '#f8f8f8',
                                        borderRadius: '12px',
                                        cursor: 'pointer'
                                    }}>
                                        <i className="bi bi-mic" style={{ fontSize: '20px', color: '#4a4a4a' }}></i>
                                        <span style={{ fontSize: '11px', color: '#6a6a6a' }}>Audio</span>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '12px',
                                        background: '#f8f8f8',
                                        borderRadius: '12px',
                                        cursor: 'pointer'
                                    }}>
                                        <i className="bi bi-geo-alt" style={{ fontSize: '20px', color: '#4a4a4a' }}></i>
                                        <span style={{ fontSize: '11px', color: '#6a6a6a' }}>Location</span>
                                    </div>
                                </div>

                                <input
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px',
                                        background: '#f8f8f8',
                                        border: 'none',
                                        borderRadius: '12px',
                                        fontSize: '14px',
                                        marginBottom: '20px',
                                        outline: 'none'
                                    }}
                                    placeholder="Add tags, price info (optional)"
                                />

                                <button style={{
                                    width: '100%',
                                    padding: '16px',
                                    background: '#2d2d2d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '16px',
                                    fontSize: '15px',
                                    fontWeight: '400',
                                    cursor: 'pointer'
                                }}>
                                    Publish Content
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* Chat Input - 只在chat标签显示 */}
                {activeTab === 'chat' && (
                    <div className="chat-input-area">
                        <input
                            className="chat-input"
                            placeholder="Enter message..."
                            value={messageInput}
                            onChange={(e) => setMessageInput(e.target.value)}
                        />
                        <button className="chat-send-btn">
                            <i className="bi bi-send"></i>
                        </button>
                    </div>
                )}

                {/* Create Modal */}
                <div className="create-modal" style={{ transform: showCreateModal ? 'translateY(0)' : 'translateY(100%)' }}>
                    <div className="modal-handle"></div>

                    <div className="modal-header">
                        <div className="modal-title-section">
                            <div className="modal-title">Create Content</div>
                        </div>
                        <button className="modal-close" onClick={() => setShowCreateModal(false)}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>

                    <input className="modal-input" placeholder="Title" />
                    <textarea className="modal-textarea" placeholder="Share your travel story..."></textarea>

                    <div className="modal-tools">
                        <div className="modal-tool">
                            <i className="bi bi-camera"></i>
                            <span>Photo</span>
                        </div>
                        <div className="modal-tool">
                            <i className="bi bi-mic"></i>
                            <span>Audio</span>
                        </div>
                        <div className="modal-tool">
                            <i className="bi bi-geo-alt"></i>
                            <span>Location</span>
                        </div>
                    </div>

                    <button className="modal-publish-btn">Publish Content</button>
                </div>
            </div>
        </>
    );
};

export default CommunityHub;